import { DOCUMENT_ACCESS_GROUPS, HOME_FOLDER_ID } from "./documents_consts.js";

$(function () {
  $(document)
    .on("click", "#open-rename-folder-modal", onRenameFolder)
    .on("click", "#delete-folder", onDeleteFolder)
    .on("click", ".documents-modal__folders-checkbox", onCheckFoldersCheckboxConsistency)
    .on("click", ".documents__folders-block", onSelectGivenFolder);
});

window.addEventListener("DOMContentLoaded", toggleCreateFolderButtonState);

function toggleCreateFolderButtonState() {
  const folderNameInput = document.getElementById("create-folder-modal-name");
  const createFolderButton = document.getElementById("create-folder-button");
  if (!folderNameInput) return;

  folderNameInput.addEventListener("input", (event) => {
    createFolderButton.disabled = event.currentTarget.value === "";
  });
}

const onRenameFolder = () => {
  const currentlySelectedFolder = document.querySelector(".documents__folder--checked");
  const inputFolderName = document.getElementById("folder-rename-input-name");
  const inputFolderId = document.getElementById("folder-rename-input-id");
  const renameFolderButton = document.getElementById("rename-folder-button");

  // Set the input for the current folder name
  inputFolderName.value = currentlySelectedFolder.dataset.folderName;
  // Set the folder_id somewhere, to have it when updating the folder
  inputFolderId.value = currentlySelectedFolder.dataset.folderId;

  inputFolderName.addEventListener("input", (event) => {
    renameFolderButton.disabled = event.currentTarget.value === "";
  });
};

const onDeleteFolder = () => {
  const checkedFolder = document.querySelector(".documents__folder--checked");
  const inputFolderId = document.getElementById("folder-delete-input-id");
  inputFolderId.value = checkedFolder.dataset.folderId;
};

// This function unselects checkboxes when one is selected
// (User may assign the document only to the one folder while uploading)
function onCheckFoldersCheckboxConsistency(event) {
  const currentSelectedFolderId = event.target.dataset.folderId;
  const folderCheckboxes = document.getElementsByClassName("documents-modal__folders-checkbox");
  [...folderCheckboxes].forEach((folderCheckboxes) => {
    const folderId = folderCheckboxes.dataset.folderId;
    if (folderCheckboxes.checked && folderId !== currentSelectedFolderId) folderCheckboxes.checked = false;
  });
}

export function onSelectGivenFolder(event) {
  // Unselect previous one
  const checkedFolder = document.querySelector(".documents__folder--checked");
  const folderName = event.currentTarget.dataset.folderName;
  const folderId = event.currentTarget.dataset.folderId;

  if (checkedFolder) {
    checkedFolder.classList.remove("documents__folder--checked");
    checkedFolder.querySelector(".documents__folders__arrow").classList.add("folders__arrow--hidden");
  }

  // Select currently selected
  event.currentTarget.classList.add("documents__folder--checked");
  event.currentTarget.querySelector(".documents__folders__arrow").classList.remove("folders__arrow--hidden");

  // If selected is not `base`/`root` folder, then show actions, otherwise hide
  if (folderId !== HOME_FOLDER_ID) {
    document.querySelector(".documents__documents-folder-actions ").classList.remove("folder-actions--hidden");
  } else {
    document.querySelector(".documents__documents-folder-actions ").classList.add("folder-actions--hidden");
  }

  changePath(folderId, folderName);
  onDisplayDocumentsByFolder(folderId);
}

// This function will filter out and show the documents, that only belong to the specific folder
function onDisplayDocumentsByFolder(folderId) {
  const documents = document.querySelectorAll(".documents-recipients__listed-documents");
  const listedRecipients = document.querySelectorAll(".documents__documents-collapsible");

  // Hide documents, that does not belong to given folder
  [...documents].forEach((document) => {
    const belongsToFolder = document.dataset.folderId === folderId;
    toggleDisplayStyle(belongsToFolder, document, "flex");
  });

  // Hide specified recipients, who do not have documents in given folder
  listedRecipients.forEach((recipient) => {
    const recipientGroup = recipient.dataset.recipientGroup;
    const listedDocuments = recipient.querySelectorAll(".documents-recipients__listed-documents");
    const documentsLength = recipient.querySelector(".documents_length_value");

    // If all are settled to display: 'none', then the specified recipient list should disappear
    const numberOfDocuments = [...listedDocuments].filter((documents) => documents.style.display !== "none").length;
    const areAllHidden = numberOfDocuments === 0;

    // Update number of documents
    documentsLength.textContent = parseInt(numberOfDocuments);

    if (recipientGroup === DOCUMENT_ACCESS_GROUPS.all) {
      const allDocumentsColumn = document.querySelector('.documents__documents-block[data-recipient-group="all"]');
      toggleDisplayStyle(!areAllHidden, allDocumentsColumn, "block");
    }
    toggleDisplayStyle(!areAllHidden, recipient, "block");
  });

  toggleCompanyAndFundingAgencyColumns(event);
}

// By default, companies and funding agencies should be hidden, and shown only when they have assigned documents
function toggleCompanyAndFundingAgencyColumns() {
  const companiesBlock = document.querySelector('.documents__documents-block[data-recipient-group="companies"]');
  const fundingAgenciesBlock = document.querySelector('.documents__documents-block[data-recipient-group="funding_agencies"]');

  const companiesDocuments = document.querySelectorAll('.collapsible-item[data-recipient-group="companies"]');
  const fundingAgenciesDocuments = document.querySelectorAll('.collapsible-item[data-recipient-group="funding_agencies"]');
  const areCompaniesDocumentsHidden = [...companiesDocuments].every((document) => document.style.display === "none");
  const areFundingAgenciesDocumentsHidden = [...fundingAgenciesDocuments].every((document) => document.style.display === "none");

  toggleDisplayStyle(!areCompaniesDocumentsHidden, companiesBlock, "block");
  toggleDisplayStyle(!areFundingAgenciesDocumentsHidden, fundingAgenciesBlock, "flex");
}

function toggleDisplayStyle(statement, element, displayStyle) {
  if (statement) {
    element.style.display = displayStyle;
  } else {
    element.style.display = "none";
  }
}

function changePath(folderId, folderName) {
  const foldersPath = document.getElementById("documents-current-path");
  if (folderId === HOME_FOLDER_ID) {
    foldersPath.textContent = "";
  } else {
    foldersPath.textContent = "> " + folderName;
  }
}
